import React, {useState, useEffect, useCallback, useRef} from 'react'

// Deps
import {connect} from 'react-redux'
import compareAsc from 'date-fns/compareAsc'
import addYears from 'date-fns/addYears';
import parseISO from 'date-fns/parseISO';
import debounce from 'lodash/debounce'
import pick from 'lodash/pick'
import omit from 'lodash/omit'

// Functions
//import stringToFloat from 'functions/string-to-float'
import formatNumber from 'functions/format-number'
import formatDate from 'functions/format-date'
import normalizePhone from 'functions/normalize-phone'

// Utils
import {openModal} from 'utils/modals';

// Partials
import Btn from 'views/shared/partials/btn'
import Collapser from 'views/shared/partials/collapser'
import {InputForm, FormInput} from 'views/shared/partials/forms'
import Loader from 'views/shared/partials/loader'
import {Table, TR, TD} from 'views/shared/partials/table'
import Pricebox from 'views/shared/partials/pricebox'

// Services
import orderServices from 'services/order'
import companyServices from 'services/company'

// Data
import invoiceTypes from 'data/invoice-types'
import currencyTypes from 'data/currency-types'
import customOrderTypes from 'data/custom-order-types'
import orderPlanPeriodTimes from 'data/order-plan-period-times'

// Hooks
import useGroups from 'hooks/groups'

const today = new Date();
const defaultExchangeType = null; //{ value: 0, label: 'Deaktif'};
const defaultCompanyPaymentType = {value: 0, label: 'Otomatik'};

const mapStateToProps = (state, ownProps) => {
	return {
		mobileState: state.site.mobile,
		userGroups: state.user.groups,
		userData: state.user.data,
	};
};

const UpdateOrderModal = (props) => {
	const isTemplate = props.template;
	const isOrderPlan = props.orderPlan;
	const userGroups = props.userGroups;
	const close = props.close;
	const orderCode = props.orderCode;

	const _mounted = useRef(false);

	const [order, setOrder] = useState(false);
	const [submitting, setSubmitting] = useState(false);
	const [activeClient, setActiveClient] = useState(false)
	const [activeClientInvoiceType, setActiveClientInvoiceType] = useState(false)

	// Payment Type Options
	const [activeCompanyPaymentType, setActiveCompanyPaymentType] = useState(defaultCompanyPaymentType);
	const [activeCompanyPaymentInstallment, setActiveCompanyPaymentInstallment] = useState(null);
	const [companyPaymentInstallmentSelectionEnabled, setCompanyPaymentInstallmentSelectionEnabled] = useState(false);

	const [orderStartDate, setOrderStartDate] = useState(today);
	const [orderDueDate, setOrderDueDate] = useState(addYears(today, 1));
	const [orderGroup, setOrderGroup] = useState(undefined);
	const [orderTotal, setOrderTotal] = useState('');
	const [orderCurrency, setOrderCurrency] = useState(undefined);
	const [orderExchangeType, setOrderExchangeType] = useState(defaultExchangeType);
	const [orderCurrencyExchangeEnabled, setOrderCurrencyExchangeEnabled] = useState(false);

	// Order Plan
	const [orderPlanPeriodMethod, setOrderPlanPeriodMethod] = useState('static');
	const [orderPlanPeriodTimeRange, setOrderPlanPeriodTimeRange] = useState(1);
	const [orderPlanPeriodTime, setOrderPlanPeriodTime] = useState(orderPlanPeriodTimes[2]);
	const [orderPlanPeriodCount, setOrderPlanPeriodCount] = useState(2);
	const [orderPlanData, setOrderPlanData] = useState(props.periods ?? false);
	const [isFirstPeriod, setIsFirstPeriod] = useState(true);
	const [orderPlanDataLoading, setOrderPlanDataLoading] = useState(false);

	const [exchangeTypes, setExchangeTypes] = useState(false);

	// const [groups, setGroups] = useState(false);

	const groups = useGroups(userGroups);

	const searchClients = (search) => {
		return new Promise((resolve, reject) => {
			companyServices.listClients({search_value: search}).then((payload) => {
				let results = payload.clients.map((client) => {
					return {
						...client,
						value: client.client_code,
						label: (client.company_name ? (client.company_name + (client.executive_name ? ' / ' : '')) : '') + client.executive_name + ' ' + client.executive_surname
					};
				})
				resolve(results);
			}).catch(() => {
				reject(false);
			})
		})
	}

	const searchCompanyPaymentTypes = (search) => {
		return new Promise((resolve, reject) => {
			companyServices.listPaymentTypes({search_value: search, per_page: 10}).then((payload) => {
				let results = payload.paymentTypes.map((type) => {
					return {
						...type,
						value: type.id,
						label: type.api_name + ' (' + type.payment_type.name + ')',
					};
				})

				if (search === '' || defaultCompanyPaymentType.label.search(new RegExp(search, 'i')) > -1) {
					results = [
						defaultCompanyPaymentType,
						...results
					];
				}

				resolve(results);
			}).catch(() => {
				reject(false);
			})
		})
	}

	const searchCompanyPaymentInstallments = (typeID, search) => {
		return new Promise((resolve, reject) => {
			companyServices.listPaymentInstallments({
				company_payment_type_id: typeID,
				search_value: search,
				per_page: 10
			}).then((payload) => {
				let results = payload.installments.map((installment) => {
					return {
						...installment,
						value: installment.id,
						label: installment.installment_calculate + ' Taksit - ' + installment.description,
					};
				});

				resolve(results);
			}).catch(() => {
				reject(false);
			})
		})
	}

	const submit = (formData) => {
		setSubmitting(true);

		const clientDataFields = ['client_invoice_type', 'client_custom_order', 'client_executive_name', 'client_executive_surname', 'client_email', 'client_phone_number'];
		const submitFunction = isTemplate ? orderServices.updateOrderTemplate : (isOrderPlan ? orderServices.updateOrderPlan : orderServices.expressOrder);

		const makeSubmission = () => {
			submitFunction(submitData).then((payload) => {
				if (props.onSuccess) {
					props.onSuccess(payload);
				}

				close();
				// if (isTemplate || isOrderPlan) {
				// 	close();
				// }
				// else {
				// 	openModal('order-summary', { orderCode: payload.order_business_code });
				// }
			}).catch(() => {
			}).finally(() => {
				setSubmitting(false);
			});
		}

		let submitData = {
			...formData,
			create_or_update_order: 'update'
		};
		let createClient = false;

		if (!formData.order_currency_exchange_type_id) {
			submitData.order_currency_exchange_type_id = '0';
		}

		if (isTemplate) {
			submitData.order_template_id = order.id;
		}
		if (isOrderPlan) {
			submitData.order_plan_id = order.id;
		} else {
			submitData.order_business_code = order.business_order_code;
		}
		if (!companyPaymentInstallmentSelectionEnabled) {
			submitData.order_company_payment_installment_ids = '0';
		}
		if (activeClient) {
			submitData.create_or_update_client = 'update';
			submitData.client_code = activeClient.client_code;
		} else if (activeClient === null) {
			// submitData.create_or_update_client = 'create';
			createClient = true;
		}

		if (createClient) {
			let userData = {
				...pick(submitData, clientDataFields),
				create_or_update_client: 'create',
			}
			orderServices.expressOrder(userData).then((payload) => {
				submitData = {
					...omit(submitData, clientDataFields),
					create_or_update_client: 'update',
					client_code: payload.client_code,
				}

				makeSubmission();
			}).catch(() => {
				openModal('message', {
					message: 'Müşteri oluşturulurken bir hata ile karşılaşıldı. Lütfen tekrar deneyin.',
					top: true,
				});
			}).finally(() => {
				setSubmitting(false);
			})
		} else {
			makeSubmission();
		}
	}

	const calculatePlanPayments = useCallback(debounce((order, periodMethod, periodCount, startDate, dueDate, orderTotal, periodTime, periodTimeRange) => {
		if (_mounted) {
			if (periodMethod && periodCount && periodTime && periodTimeRange && startDate && dueDate && orderTotal) {
				setOrderPlanDataLoading(true);
				orderServices.calculateOrderPlan(
					periodTime.value,
					periodTimeRange,
					(periodMethod === 'dynamic' ? 1 : periodCount),
					formatDate(startDate, 'yyyy-MM-dd', {parsed: true}),
					formatDate(dueDate, 'yyyy-MM-dd', {parsed: true}),
					orderTotal.replace(/\./g, '').replace(',', '.'),
					order.id
				).then((payload) => {
					setOrderPlanData(payload);
				}).catch(() => {
					setOrderPlanData(false);
				}).finally(() => {
					setOrderPlanDataLoading(false);
				})
			} else {
				setOrderPlanDataLoading(false);
				setOrderPlanData(false);
			}
		}
	}, 500, {leading: false}), []);

	useEffect(() => {
		if (isOrderPlan && order && !isFirstPeriod) {
			calculatePlanPayments(
				order,
				orderPlanPeriodMethod,
				orderPlanPeriodCount,
				orderStartDate,
				orderDueDate,
				orderTotal,
				orderPlanPeriodTime,
				orderPlanPeriodTimeRange,
			);
		}
	}, [
		order,
		isOrderPlan,
		orderPlanPeriodMethod,
		orderPlanPeriodCount,
		orderStartDate,
		orderDueDate,
		orderTotal,
		orderPlanPeriodTime,
		orderPlanPeriodTimeRange,
		calculatePlanPayments
	])

	useEffect(() => {
		const getData = () => {
			const getFunction = isTemplate ? orderServices.getOrderTemplate : (isOrderPlan ? orderServices.getOrderPlan : orderServices.getOrder);

			getFunction(orderCode).then((payload) => {
				setOrder(payload);

				// Plan Settings
				if (isOrderPlan) {
					if (payload.period_count === 1) {
						setOrderPlanPeriodMethod('dynamic');
					} else {
						setOrderPlanPeriodMethod('static');
						setOrderPlanPeriodCount(payload.period_count);
					}

					setOrderPlanPeriodTime(orderPlanPeriodTimes.find((time) => {
						return time.value === payload.period_time;
					}));

					setOrderPlanPeriodTimeRange(payload.period_time_range);

					setOrderPlanData(payload.periods);
				}

				setOrderTotal(formatNumber(payload.total_amount));

				setOrderGroup(groups.find((group) => {
					return group.value === payload.group.store_code;
				}));

				setOrderCurrency(currencyTypes.find((type) => {
					return type.value.toString() === payload.price_type.id.toString();
				}));

				setActiveClient({
					...payload.client,
					value: payload.client.client_code,
					label: (payload.client.company_name ? (payload.client.company_name + (payload.client.executive_name ? ' / ' : '')) : '') + payload.client.executive_name + ' ' + payload.client.executive_surname
				});

				if (payload.currency_exchange_type_id) {
					setOrderCurrencyExchangeEnabled(true);
				}

				if (payload.company_payment_type) {
					setActiveCompanyPaymentType({
						...payload.company_payment_type,
						value: payload.company_payment_type.id,
						label: payload.company_payment_type.api_name + ' (' + payload.company_payment_type.payment_type.name + ')',
					})

					if (payload.company_payment_installments && payload.company_payment_installments.length) {
						setActiveCompanyPaymentInstallment(payload.company_payment_installments.map((installment,) => {
							return {
								...installment,
								value: installment.id,
								label: installment.installment_calculate + ' Taksit - ' + installment.description,
							};
						}));

						setCompanyPaymentInstallmentSelectionEnabled(true);
					}
				}

				companyServices.listExchangeTypes({client_code: payload.client_code}).then((types) => {
					let results = types.map((type) => {
						return {
							...type,
							value: type.id,
							label: type.name,
						};
					})

					let activeExchangeType = results.find((result) => {
						return result.id ? result.id === payload.currency_exchange_rate.id : false;
					});

					if (payload.currency_exchange_type_id) {
						setOrderCurrencyExchangeEnabled(true);
					}

					setOrderExchangeType(activeExchangeType ? activeExchangeType : defaultExchangeType);

					setExchangeTypes(results);
				}).catch(() => {
					setExchangeTypes([defaultExchangeType]);
				})

				setOrderStartDate(parseISO(payload.created_at));
				setOrderDueDate(parseISO(payload.due_date));
			}).catch(() => {
				close();
			})
				.finally(() => setIsFirstPeriod(false))
		}

		if (groups && groups.length) {
			getData();
		}
	}, [close, orderCode, groups, isTemplate, isOrderPlan]);

	useEffect(() => {
		if (orderStartDate && orderDueDate) {
			if (compareAsc(orderStartDate, orderDueDate) === 1) {
				setOrderDueDate(false);
			}
		}
	}, [orderStartDate, orderDueDate])

	useEffect(() => {
		setActiveClientInvoiceType(invoiceTypes[activeClient ? (activeClient.invoice_type - 1) : 0]);
	}, [activeClient])

	useEffect(() => {
		_mounted.current = true;

		return (() => {
			_mounted.current = false;
		})
	})

	return (
		<InputForm
			ignoreEmpty
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header dark">
				<h1 className="header-title">
					{isTemplate ?
						<React.Fragment><span>Hazır Ödeme Şablonunu Düzenle</span><span className="label category-template">Ödeme Şablonları</span></React.Fragment>
						:
						'Ödeme Talebini Düzenle'
					}
				</h1>
				{props.closeBtn}
			</div>

			<div className="modal-content loader-container">
				<Loader loading={order === false}/>

				{order &&
				<React.Fragment>

					{order.client.client_code === 'anonim' &&
					<Collapser
						className="modal-group dark"
						open disableToggle
						title="Müşteri Seçimi">
						<div className="order-clientselect">
							<div className="clientselect-form">

								<FormInput
									disabled={submitting}
									type="select"
									placeholder="Yeni Müşteri"
									label="Müşteri Seçin"
									async
									defaultOptions
									z="6"
									onChange={(client) => {
										if (client) {
											client.phone_number = client.phone_number ? normalizePhone(client.phone_number) : client.phone_number;
										}
										setActiveClient(client);
									}}
									loadOptions={searchClients}
									value={activeClient}
									className="form-select"/>

								<div className="form-controls">
									<span className="controls-seperator">veya</span>

									<Btn
										big={props.mobileState ? undefined : true}
										icon="user-add"
										onClick={() => {
											setActiveClient(null)
										}}
										className="controls-newbtn">
										Yeni Müşteri
									</Btn>
								</div>
							</div>
						</div>

						{((activeClient && activeClient.client_code !== 'anonim') || activeClient === null) &&
						<div className="grid-container">
							<div className="row">
								<div className="col x8">
									<FormInput
										disabled={activeClient !== null}
										type="select"
										z="1"
										label="Müşteri Tipi"
										options={invoiceTypes}
										onChange={setActiveClientInvoiceType}
										name={activeClient === null ? 'client_invoice_type' : undefined}
										value={activeClientInvoiceType}/>
								</div>
								<div className="col x4">
									<FormInput
										disabled={activeClient !== null}
										type="select"
										z="1"
										label="Serbest Ödeme Özelliği"
										options={customOrderTypes}
										name={activeClient === null ? 'client_custom_order' : undefined}
										value={activeClient ? customOrderTypes[activeClient.custom_order === 1 ? 0 : 1] : customOrderTypes[0]}/>
								</div>
							</div>
							<div className="row">
								<div className="col x6">
									<FormInput
										disabled={activeClient !== null}
										type="text"
										label={(activeClientInvoiceType.value === 1) ? 'Müşteri Adı' : 'Yetkili Adı'}
										validation={activeClient === null ? {
											required: (activeClientInvoiceType.value === 1 ? 'Müşteri' : 'Yetkili') + ' adı girmelisiniz',
										} : undefined}
										name={activeClient === null ? 'client_executive_name' : undefined}
										value={activeClient ? activeClient.executive_name : undefined}/>
								</div>
								<div className="col x6">
									<FormInput
										disabled={activeClient !== null}
										type="text"
										label={(activeClientInvoiceType.value === 1) ? 'Müşteri Soyadı' : 'Yetkili Soyadı'}
										validation={activeClient === null ? {
											required: (activeClientInvoiceType.value === 1 ? 'Müşteri' : 'Yetkili') + ' soyadı girmelisiniz',
										} : undefined}
										name={activeClient === null ? 'client_executive_surname' : undefined}
										value={activeClient ? activeClient.executive_surname : undefined}/>
								</div>
							</div>
							<div className="row">
								<div className="col x6">
									<FormInput
										disabled={activeClient !== null}
										type="email"
										label="E-Posta"
										validation={activeClient === null ? {
											required: "E-posta adresi girmelisiniz",
											email: "Geçerli bir e-posta girmelisiniz",
										} : undefined}
										name={activeClient === null ? 'client_email' : undefined}
										value={activeClient ? activeClient.email : undefined}/>
								</div>
								<div className="col x6">
									<FormInput
										type="phone"
										disabled={activeClient !== null}
										mask="phone"
										label="Cep Telefonu"
										validation={activeClient === null ? {
											required: "Cep telefonu girmelisiniz",
											phone: "Geçerli bir telefon numarası girmelisiniz",
										} : undefined}
										name={activeClient === null ? 'client_phone_number' : undefined}
										value={activeClient ? activeClient.phone_number : undefined}/>
								</div>
							</div>
						</div>
						}
					</Collapser>
					}

					<Collapser
						className="modal-group dark"
						title="Ödeme Bilgileri"
						open disableToggle>
						<div className="grid-container">
							<div className="row">
								<div className="col x8">
									<FormInput
										disabled={submitting}
										type="number"
										label="Ödeme Tutarı"
										mask="number"
										validation={{
											required: "Ödeme tutarını girmelisiniz"
										}}
										decimals={2}
										onChange={(val) => {
											setOrderTotal(val);
										}}
										value={orderTotal}
										name="order_total_amount"/>
								</div>
								<div className="col x4">
									<FormInput
										disabled={submitting}
										type="select"
										z="4"
										defaultValue={orderCurrency}
										label="Para Birimi"
										value={orderCurrency}
										onChange={(cur) => {
											setOrderCurrency(cur);
										}}
										options={currencyTypes}
										name="order_price_type_id"/>
								</div>
							</div>
							{(orderCurrency && orderCurrency.value !== '1') &&
							<React.Fragment>
								<div className="row lined">
									<div className="col x12">
										<FormInput
											disabled={submitting}
											type="checkbox"
											checked={orderCurrencyExchangeEnabled}
											onChange={(val) => {
												setOrderCurrencyExchangeEnabled(val ? true : false);
											}}
											value={1}
											label="Ödeme anında döviz kuru ile çevrilir ve Türk Lirası olarak ödenir"/>
									</div>
								</div>
								{orderCurrencyExchangeEnabled &&
								<div className="row">
									<div className="col x8 no-gap-top">
										<FormInput
											disabled={submitting}
											type="select"
											placeholder="Çevirme Yöntemi Seçin"
											label="Döviz Çevirme Yöntemi"
											z="4"
											defaultOption={defaultExchangeType}
											validation={{
												required: 'Bir döviz çevirme yöntemi seçin',
											}}
											onChange={(type) => {
												setOrderExchangeType(type);
											}}
											options={exchangeTypes}
											name="order_currency_exchange_type_id"
											value={orderExchangeType}/>

										{(orderExchangeType && orderExchangeType.currency && !orderExchangeType.currency[orderCurrency.code]) &&
										<p className="order-conversionnote">Ödeme hesaplamaları gireceğiniz kur üzerinden
											hesaplanacaktır.</p>
										}
									</div>
									{orderExchangeType &&
									<div className="col x4 no-gap-top">
										<FormInput
											disabled={submitting || (!(orderExchangeType.code === 'Company' && props.userData && props.userData.is_owner) && (orderExchangeType && orderExchangeType.currency && orderExchangeType.currency[orderCurrency.code]))}
											type="number"
											decimals={2}
											label="Mevcut Kur"
											placeholder="Kur Girin"
											mask="number"
											value={(orderExchangeType.currency && orderExchangeType.currency[orderCurrency.code]) ? formatNumber(orderExchangeType.currency[orderCurrency.code]) : (order.currency_exchange_rate.rate ? formatNumber(order.currency_exchange_rate.rate) : undefined)}
											validation={{
												required: "Döviz kuru girmelisiniz"
											}}
											name="order_currency_exchange_rate"/>
									</div>
									}
								</div>
								}
							</React.Fragment>
							}
							<div className="row lined">
								<div className="col x4">
									<FormInput
										disabled={submitting}
										type="select"
										isSearchable
										z="3"
										readOnly={groups.length < 1}
										label="Ödeme Grubu"
										placeholder="Bir ödeme grubu seçin"
										options={groups}
										defaultValue={orderGroup}
										name="order_store_code"/>
								</div>
								<div className="col x4">
									<FormInput
										disabled
										type="date"
										z="2"
										label="Başlangıç Tarihi"
										placeholder="Başlangıç Tarihi Seçin"
										onChange={(value) => {
											setOrderStartDate(value);
										}}
										value={orderStartDate}
										name="order_start_date"/>
								</div>
								{!isTemplate &&
								<div className="col x4">
									<FormInput
										disabled={submitting}
										type="date"
										z="1"
										label="Son Ödeme Tarihi"
										placeholder="Son Ödeme Tarihi Seçin"
										minDate={orderStartDate ? orderStartDate : undefined}
										onChange={(value) => {
											setOrderDueDate(value);
										}}
										value={orderDueDate}
										name="order_due_date"/>
								</div>
								}
							</div>
							<div className="row">
								<div className="col x10">
									<FormInput
										disabled={submitting}
										type="textarea"
										label="Açıklama"
										rows={3}
										value={order.description ? order.description : undefined}
										name="order_description"/>
								</div>
							</div>
						</div>
					</Collapser>

					{isOrderPlan &&
					<Collapser
						className="modal-group order-plan"
						title="Periyodik Ödeme">
						<div className="collapser-section">
							<div className="portlet gray  plan-interval">
								<div className="portlet-header">
									<strong className="portlet-title">Tekrar Aralığı</strong>
								</div>
								<div className="portlet-section bottom interval-inputwrap">
									<span>Her</span>
									<FormInput
										disabled={submitting}
										className="interval-range"
										type="number"
										value={orderPlanPeriodTimeRange}
										onChange={(val) => {
											setOrderPlanPeriodTimeRange(val);
										}}
										name="order_period_time_range"/>
									<FormInput
										disabled={submitting}
										className="interval-period"
										type="select"
										value={orderPlanPeriodTime}
										onChange={(val) => {
											setOrderPlanPeriodTime(val);
										}}
										options={orderPlanPeriodTimes}
										name="order_period_time"/>
								</div>
							</div>
							<div className="portlet gray  plan-installments">
								<div className="portlet-header">
									<strong className="portlet-title">Taksit Adedi</strong>
								</div>
								<div className="portlet-section bottom">
									<div className="grid-container">
										<div className="row">
											<div className="col x12">
												<FormInput
													disabled={submitting}
													type="radio"
													name="plan_period_method"
													value={orderPlanPeriodMethod}
													onChange={(val) => {
														setOrderPlanPeriodMethod(val);
													}}
													options={[
														{
															value: 'static',
															label: 'Elle Gir',
														},
														{
															value: 'dynamic',
															label: 'Son ödeme tarihine göre otomatik hesapla',
														},
													]}/>
											</div>
										</div>
										{orderPlanPeriodMethod === 'static' &&
										<div className="row">
											<div className="col x8 installments-inputwrap">
												<span>Talebi</span>
												<FormInput
													disabled={submitting}
													type="number"
													value={orderPlanPeriodCount}
													onChange={(val) => {
														setOrderPlanPeriodCount(val);
													}}
													className="installments-count"
													name="order_period_count"/>
												<span>ödemeye böl.</span>
											</div>
										</div>
										}
									</div>
								</div>
							</div>
							<div className="portlet plan-data loader-container">
								<Loader loading={orderPlanDataLoading}/>
								<div className="portlet-header border-bottom">
									<strong className="portlet-title">Plan Önizlemesi</strong>
								</div>
								<div className="portlet-section bottom">
									{(orderPlanData && order && orderCurrency) ?
										<Table
											emptyMessage="Bir hata oluştu."
											className="data-table"
											heading={
												<React.Fragment>
													<th>Dönem</th>
													<th>Ödeme Tarihi</th>
													<th>Tutar</th>
												</React.Fragment>
											}>
											{orderPlanData.map((data, nth) => (
												<TR key={nth} /*mobileTitle={nth + 1 + '. Talep'}*/>
													<TD>
														{nth + 1}. Dönem
													</TD>
													<TD>
														{formatDate(data.date, 'd MMMM yyyy')}
													</TD>
													<TD>
														<Pricebox
															price={data.price}
															currency={orderCurrency.symbol}/>
													</TD>
												</TR>
											))}
										</Table>
										:
										<div className="alert warning center">
											<div className="alert-content">
												Periyodik ödeme planını tanımlamak için ödeme tutarını ve periyot bilgilerini girmelisiniz.
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					</Collapser>
					}

					<Collapser
						className="modal-group"
						title="Detaylı Sipariş Bilgileri">
						<div className="grid-container">
							<div className="row">
								<div className="col x6">
									<FormInput
										disabled
										type="text"
										label="İşletme Sipariş Kodu"
										value={order.business_order_code}
										name="order_business_code"/>
								</div>
								<div className="col x6">
									<FormInput
										disabled={submitting}
										type="text"
										label="Fatura No"
										value={order.invoice_no ? order.invoice_no : undefined}
										name="order_invoice_no"/>
								</div>
							</div>
							<div className="row">
								<div className="col x12">
									<FormInput
										disabled={submitting}
										type="select"
										z="2"
										name="order_company_payment_type_id"
										placeholder="Sabitlemek için bir ödeme aracı seçin"
										label="Ödeme Aracını Sabitle"
										async
										defaultOptions
										onChange={setActiveCompanyPaymentType}
										loadOptions={searchCompanyPaymentTypes}
										value={activeCompanyPaymentType}
										className="clientselect-select"/>
								</div>
							</div>
							{activeCompanyPaymentType && activeCompanyPaymentType.value !== 0 &&
							<React.Fragment>
								<div className="row">
									<div className="col x12">
										<FormInput
											disabled={submitting}
											type="checkbox"
											checked={companyPaymentInstallmentSelectionEnabled}
											onChange={(val) => {
												setCompanyPaymentInstallmentSelectionEnabled(val ? true : false);
											}}
											value={1}
											label="Taksit seçeneklerini sınırla"/>
									</div>
								</div>
								{companyPaymentInstallmentSelectionEnabled &&
								<div className="row">
									<div className="col x12 no-gap-top">
										<FormInput
											key={activeCompanyPaymentType.value}
											disabled={submitting}
											type="select"
											name="order_company_payment_installment_ids"
											placeholder="Taksit seçeneklerini seçin"
											label="Taksitler"
											async
											defaultOptions
											multiple
											onChange={setActiveCompanyPaymentInstallment}
											loadOptions={(search) => {
												return searchCompanyPaymentInstallments(activeCompanyPaymentType.value, search);
											}}
											validation={{
												required: "En az bir taksit seçeneği seçmelisiniz.",
											}}
											value={activeCompanyPaymentInstallment}/>
									</div>
								</div>
								}
							</React.Fragment>
							}
						</div>
					</Collapser>
				</React.Fragment>
				}
			</div>

			<div className="modal-controls">
				<Btn
					nude
					disabled={submitting}
					onClick={props.close}>
					Vazgeç
				</Btn>
				<Btn
					loading={submitting}
					disabled={submitting || (order === false)}
					type="submit">
					Güncelle
				</Btn>
			</div>
		</InputForm>
	)
}

const ConnectedModal = connect(mapStateToProps)(UpdateOrderModal);

ConnectedModal.defaultProps = {
	className: '',
	containerClass: 'modal-create-or-update-order mobile-full',
	name: 'update-order',
	title: false,
	content: false,
	source: false,
	orderCode: false,
	template: false,
	plan: false,
}

export default ConnectedModal
